import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthState } from '../state/auth/auth.state';
import { login } from '../state/auth/auth.actions';
import { jwtDecode } from 'jwt-decode';
import { MyJwtPayload, User } from '../interfaces/user-interfaces';

@Injectable({
  providedIn: 'root',
})
export class AuthInitializerService {
  constructor(private store: Store<AuthState>) {}

  /**
   * 1. On app start, look for a saved auth token in localStorage.
   * 2. If found, decode the JWT to extract the user's email (sub property)
   * 3. Then dispatch the login action so NgRx knows we're already signed in.
   * 4. The profile sidebar will search user preferances by this email
   */
  rehydrateAuthState(): Promise<void> {
    return new Promise((resolve) => {
      const savedAuthState = localStorage.getItem('auth');
      if (savedAuthState) {
        const { token } = JSON.parse(savedAuthState);
        try {
          const decoded = jwtDecode<MyJwtPayload>(token);
          const user: User = {
            email: decoded.sub,
            id: undefined,
            role: undefined,
          };
          this.store.dispatch(login({ token, user }));
        } catch {
          console.error('Invalid token');
        }
      }
      resolve();
    });
  }
}

export function initializeAuth(authInitializer: AuthInitializerService): () => Promise<void> {
  return () => authInitializer.rehydrateAuthState();
}
